import { ReportItem } from './report-item';
import { ReportStackedPartition } from './report-stacked-partition';

export class ReportCustom {
    id: number;
    articleType: string;
    partitionsCodes: string[];
    stackedPartitions: ReportStackedPartition[];
    reportItems: ReportItem[];

    constructor(id: number, articleType?: string, partitionsCodes?: string[], reportItem?: ReportItem) {
        this.id = id;
        this.articleType = articleType || null;
        this.reportItems = reportItem ? [reportItem] : null;

        this.partitionsCodes = partitionsCodes || [];
    }
}
